module.exports = __webpack_public_path__ + "static/media/natural-stone-black.12ca775b.svg";